
import React from "react";
import { Badge } from "@/components/ui/badge";
import { CheckCircle } from "lucide-react";

interface Lesson {
  id: string;
  title: string;
  description: string | null;
  video_url: string | null;
  image_url: string | null;
  lesson_order: number;
}

interface CourseLessonsListProps {
  lessons: Lesson[];
  isEnrolled: boolean;
  courseStatus: string;
}

const CourseLessonsList = ({ lessons, isEnrolled, courseStatus }: CourseLessonsListProps) => {
  if (lessons.length === 0) {
    return null;
  }

  return (
    <div className="mb-8">
      <h2 className="text-xl font-semibold mb-4">Course Content</h2>
      <div className="border rounded-lg overflow-hidden">
        <div className="bg-gray-50 px-4 py-3 border-b">
          <p className="text-sm font-medium">{lessons.length} Lessons</p>
        </div>
        <ul className="divide-y">
          {lessons.map((lesson, index) => (
            <li key={lesson.id} className="px-4 py-3 flex items-center">
              <div className="mr-3 w-6 h-6 flex items-center justify-center rounded-full bg-gray-100">
                <span className="text-xs font-medium">{index + 1}</span>
              </div>
              <div className="flex-grow">
                <h3 className="font-medium">{lesson.title}</h3>
                {lesson.description && (
                  <p className="text-sm text-gray-500 mt-1">{lesson.description}</p>
                )}
              </div>
              {isEnrolled ? (
                <CheckCircle className="h-5 w-5 text-green-500" />
              ) : (
                <Badge variant="outline" className="ml-2">
                  Preview {courseStatus === "Enrolling" ? "Available" : "Coming Soon"}
                </Badge>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CourseLessonsList;
